<template>
  <div>
    <b-select
      v-model="risk.riskTypeId"
      :error-messages="getErrorMessages(v$.riskTypeId)"
      :items="$directory.get('riskTypes')"
      :loading="$loading.isLoading('riskTypes')"
      label="Вид ризику"
      @blur="v$.riskTypeId.$touch()"
      @focus="$directory.fill('riskTypes')"></b-select>
    <b-select
      v-model="risk.riskLevelId"
      :error-messages="getErrorMessages(v$.riskLevelId)"
      :items="$directory.get('riskLevels')"
      :loading="$loading.isLoading('riskLevels')"
      label="Рівень ризику"
      @blur="v$.riskLevelId.$touch()"
      @focus="$directory.fill('riskLevels')">
      <template #item="{ props, item }">
        <v-list-item v-bind="props">
          <template #prepend>
            <v-icon
              :color="riskColors[item.raw.id]"
              icon="mdi-circle"
              size="small" />
          </template>
        </v-list-item>
      </template>
      <template #selection="{ item }">
        <div class="d-flex align-center ga-2">
          <v-icon
            :color="riskColors[item.raw.id]"
            icon="mdi-circle"
            size="small" />
          <span>{{ item.raw.name }}</span>
        </div>
      </template>
    </b-select>
  </div>
</template>

<script lang="ts">
import { PropType, reactive } from 'vue'
import { Dialog } from '@/dialog'
import { getErrorMessages } from 'best-modules/utils'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { auditRiskCreate } from '@/requests/audit'

export default {
  name: 'AuditRisk',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    const riskColors: Record<number, string> = {
      1: 'green',
      2: 'light-green',
      3: 'orange',
      4: 'red',
    }

    const risk = reactive({
      riskTypeId: null,
      riskLevelId: null,
      auditFlawId: props.dialog.dialogData.flawId,
    })

    const rules = {
      riskTypeId: { required: required },
      riskLevelId: { required: required },
    }

    const v$ = useVuelidate(rules, risk)

    const submit = () => {
      return auditRiskCreate(risk).then(res => {
        return res
      })
    }

    return { risk, v$, submit, riskColors }
  },
}
</script>

<style lang="scss" scoped></style>
